/**
 * Added to entities that should not be deletable from scene
 */
class NonDeletableComponent {
    constructor() {
        this.typeId = NonDeletableComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
NonDeletableComponent.id = 2095;
export default NonDeletableComponent;
//# sourceMappingURL=NonDeletableComponent.js.map